import UserUsernameEditStep from './UserUsernameEditStep';
import { withPopup } from './Utils';

export default withPopup(UserUsernameEditStep);
